import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var BlogFooterQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query blogFooterQuery {\n    blogFooter {\n      linkList {\n        text\n        href\n      }\n    }\n  }\n"])));
export default BlogFooterQuery;